import * as React from "react";
import { forwardRef } from "react";
const SvgExport = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18.001, viewBox: "0 0 18 18.001", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.535 18H.999V0h15.069v3c0 1.647-.021 3-.057 3a9 9 0 0 1-.766-.719l-.711-.712V1.535h-12v14.929h12v-3.033l.711-.713a9 9 0 0 1 .766-.718c.036 0 .057 1.346.057 3v3zm4.255-5.757-.558-.558.955-.955.964-.964h-7.22V8.232h7.22l-.964-.964-.955-.955.537-.546a7 7 0 0 1 .579-.536c.021 0 .885.851 1.919 1.884l1.883 1.883-1.9 1.9-1.9 1.906z" }));
const ForwardRef = forwardRef(SvgExport);
export { ForwardRef as ReactComponent };
